module.exports = __webpack_public_path__ + "static/media/24a.93c7eb48.jpg";